<form
  *ngIf="(state$ | async)?.form as form"
  [formGroup]="form"
  class="form">
  <mat-form-field>
    <input
      matInput
      formControlName="codiceUnico"
      [placeholder]="'Codice Unico' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="titolo"
      [placeholder]="'Titolo' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="note"
      [placeholder]="'Note' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="tag"
      [placeholder]="'Tag' | translate">
  </mat-form-field>
</form>
